import { useState } from 'react';

function Navbar({ activePage, setActivePage, onSignOut, userEmail }) {
  const pages = ['Home', 'Cheat Sheet', 'Deal Calculator', 'Auction Tracker', 'Auction Platforms', 'Due Diligence', 'AI Research'];
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav style={{ backgroundColor: '#1a1a2e', padding: '12px 16px' }}>
      {/* Main row */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <img src={require('../BYG_with_background_color.png')} alt="BYG" style={{ height: '44px', borderRadius: '6px' }} />

        {/* Desktop nav + sign out */}
        <div className="desktop-nav" style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
          {pages.map(page => (
            <button
              key={page}
              onClick={() => setActivePage(page)}
              style={{
                backgroundColor: activePage === page ? '#c9a84c' : 'transparent',
                color: 'white',
                border: '1px solid #c9a84c',
                padding: '7px 14px',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: activePage === page ? 'bold' : 'normal',
                fontSize: '13px',
              }}
            >
              {page === 'Cheat Sheet' ? 'State Playbook' : page}
            </button>
          ))}
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginLeft: '8px', paddingLeft: '8px', borderLeft: '1px solid rgba(255,255,255,0.2)' }}>
            <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '11px' }}>{userEmail}</span>
            <button
              onClick={onSignOut}
              style={{
                backgroundColor: 'transparent', border: '1px solid rgba(255,255,255,0.3)',
                color: 'white', padding: '5px 10px', borderRadius: '4px',
                cursor: 'pointer', fontSize: '11px', whiteSpace: 'nowrap'
              }}
            >
              Sign Out
            </button>
          </div>
        </div>

        {/* Hamburger button - mobile only */}
        <div className="hamburger" style={{ display: 'none', alignItems: 'center', gap: '8px' }}>
          <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '11px' }}>{userEmail}</span>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            style={{
              background: 'none', border: '1px solid #c9a84c',
              color: '#c9a84c', padding: '6px 10px',
              borderRadius: '4px', cursor: 'pointer', fontSize: '18px',
            }}
          >
            {menuOpen ? '✕' : '☰'}
          </button>
        </div>
      </div>

      {/* Mobile dropdown menu */}
      {menuOpen && (
        <div className="mobile-nav" style={{ marginTop: '12px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {pages.map(page => (
            <button
              key={page}
              onClick={() => { setActivePage(page); setMenuOpen(false); }}
              style={{
                backgroundColor: activePage === page ? '#c9a84c' : 'transparent',
                color: 'white', border: '1px solid #c9a84c',
                padding: '10px 16px', borderRadius: '4px',
                cursor: 'pointer', fontWeight: activePage === page ? 'bold' : 'normal',
                fontSize: '14px', textAlign: 'left',
              }}
            >
              {page === 'Cheat Sheet' ? 'State Playbook' : page}
            </button>
          ))}
          <button
            onClick={onSignOut}
            style={{
              backgroundColor: 'transparent', border: '1px solid rgba(255,255,255,0.3)',
              color: 'rgba(255,255,255,0.7)', padding: '10px 16px',
              borderRadius: '4px', cursor: 'pointer', fontSize: '14px', textAlign: 'left',
            }}
          >
            Sign Out
          </button>
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .hamburger { display: flex !important; }
          .desktop-nav { display: none !important; }
        }
        @media (min-width: 769px) {
          .mobile-nav { display: none !important; }
        }
      `}</style>
    </nav>
  );
}

export default Navbar;
